<template>
  <transition v-bind="modalTransition">
    <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div class="mx-auto max-w-sm bg-white p-4 shadow-4">
        <h2 class="mb-4 text-xl font-semibold">
          {{ t('groups.message_delete_confirmation') }}
        </h2>
        <p
          class="mb-4"
          v-html="
            t('globals.sure', {
              label: `<strong>${streamName}</strong>`,
            })
          "></p>
        <div class="flex justify-end">
          <button @click="cancel" class="mr-2 px-4 py-2 text-slate-500 hover:text-slate-400">
            {{ t('globals.buttons.cancel') }}
          </button>
          <button @click="confirm" class="bg-red px-4 py-2 text-white hover:bg-rose-500">
            <span v-if="!isDeleting">{{ t('globals.buttons.remove') }}</span>
            <ButtonLoader v-else />
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'
import ButtonLoader from '@/components/Globals/Feedbacks/ButtonLoader.vue'
import { useI18n } from '@/composable/useI18n'
import { modalTransition } from '@/plugins/transitions'

const { t } = useI18n()

const props = defineProps<{
  isOpen: boolean
  streamName: string
  isDeleting: boolean
}>()

const emit = defineEmits(['close', 'confirm'])

function cancel() {
  emit('close')
}

function confirm() {
  emit('confirm')
}
</script>
